import React from 'react';
import { Box } from '@mui/material';

import MarketplacePageTitle from '../MarketplacePageTitle/MarketplacePageTitle';

export interface IMarketplaceLayoutProps {
  header: React.ReactNode;
  children?: React.ReactNode;
}

const MarketplaceLayout = ({ header, children }: IMarketplaceLayoutProps): JSX.Element => (
  <Box bgcolor="common.white">
    {header}
    <Box width={1} display="flex" flexDirection="column" justifyContent="flex-start">
      <MarketplacePageTitle />
      {children}
    </Box>
  </Box>
);

export default MarketplaceLayout;
